import { ANONYMOUS_ID } from '@canvas/model/identity';

import { getSessionData } from './get-session-data.ts';

/**
 * Determines whether the user is anonymous based on the feature flag
 */
export function isAnonymous() {
  const accountId = getSessionData()?.accountId;

  return accountId === ANONYMOUS_ID || accountId === undefined;
}

export function isNonAnonymous() {
  return !isAnonymous();
}
